import { useEffect, useState } from "react";
import ActionButton from "../common/action-button/ActionButton";
import InputAmountMint from "../common/input-amount/InputAmountMint";
import { RedemptionAction } from "./Redemption";
import InputMaxButtonMintClaim from "../common/input-max-button-claim/InputMaxButtonMintClaim";

type Props = {
  setRedemptionAction: (action: RedemptionAction) => void;
  handleClaim: (amount: number) => Promise<void>;
  calculateClaimableUSDCAmountPhaseTwo: () => number;
};
export default function Claim({
  calculateClaimableUSDCAmountPhaseTwo,
  handleClaim,
}: Props) {
  const connected = true;

  const USDC = window.__UXD__.solana.config.getMintInfo("USDC");
  const claimableUsdcAmount = calculateClaimableUSDCAmountPhaseTwo();
  const claimable = false;
  const [amount, setAmount] = useState("");
  const doClaim = async (usdcAmount: number) => {
    await handleClaim(usdcAmount);
    setAmount("");
  };

  return (
    <>
      <div className="Redemption-Title">
        <h2>Claim your USDC</h2>
        <p>Claim Illiquid USDC.</p>
        <p>This can be repeated over time as USDC funds become available.</p>
      </div>
      <div className="Redemption-Input">
        <div className="Redemption-Content-Detail">
          <label htmlFor="amount-input">Claim USDC</label>
          <InputMaxButtonMintClaim
            balance={claimableUsdcAmount}
            activeMint={USDC}
            handleClick={
              !claimable
                ? (amount: string) => {
                    setAmount(amount);
                  }
                : undefined
            }
          />
        </div>

        <InputAmountMint
          id="amount-input"
          name="amount"
          amount={amount}
          handleChange={setAmount}
          disabled={false}
          reset={connected}
          mint={window.__UXD__.solana.config.getMintInfo("USDC")}
        />
      </div>

      <div className="Redemption-Action">
        <ActionButton
          color="green"
          label={"Claim"}
          disabled={
            !connected ||
            !claimableUsdcAmount ||
            Number(claimableUsdcAmount) === 0
          }
          form={"Redemption"}
          type="submit"
          onClick={() => doClaim(Number(amount))}
        />
      </div>
    </>
  );
}
